import i18n from 'i18next';

import { initReactI18next } from 'react-i18next';

import {
    deDE,
    enUS,
    esLA,
    frCA,
    frFR,
    hiIN,
    jaJP,
    koKR,
    ptBR,
    zhCN,
} from 'src/public/locales/languages';
import { getPreferredLanguage } from 'src/shared/helpers/getPreferredLanguage';

import { config } from './config';

// languages that are completed and ready for production use
const prodResources = {
    'en-US': enUS,
    'fr-CA': frCA,
    'zh-Hans': zhCN,
    ko: koKR,
    fr: frFR,
    ja: jaJP,
    es: esLA,
};

const resources = {
    'en-US': enUS,
    'fr-CA': frCA,
    'zh-Hans': zhCN,
    ko: koKR,
    fr: frFR,
    ja: jaJP,
    es: esLA,
    de: deDE,
    hi: hiIN,
    pt: ptBR,
};

i18n.use(initReactI18next).init({
    resources: process.env.REACT_APP_ENV === 'production' ? prodResources : resources,
    lng: getPreferredLanguage(),
    initImmediate: false,
    fallbackLng: config.defaultLanguage,
    interpolation: {
        escapeValue: false,
    },
    cleanCode: true,
    keySeparator: false,
});

// tslint:disable-next-line:no-default-export
export default i18n;
